import { defineMessages } from "react-intl"

export const marketExportMessages = defineMessages({
	currentMonth: {
		defaultMessage: "Current month",
		id: "dealerList.marketExport.timeFrame.currentMonth",
	},
	customSelection: {
		defaultMessage: "Custom",
		id: "dealerList.marketExport.timeFrame.custom",
	},
	deliveredVehicles: {
		defaultMessage: "Delivered",
		id: "salesStatus.delivered", // shared
	},
	downloadAsExcel: {
		defaultMessage: "Download as Excel",
		id: "dealerList.marketExport.downloadAsExcel",
	},
	endDate: {
		defaultMessage: "End date",
		id: "dealerList.marketExport.timeFrame.endDate",
	},
	exportPeriod: {
		defaultMessage: "Export period: {startDate} - {endDate}",
		id: "dealerList.marketExport.timeFrame.exportPeriod",
	},
	inStockVehicles: {
		defaultMessage: "In Stock",
		id: "vehicle.stockStatus.inStock", // shared
	},
	intro: {
		defaultMessage:
			"The file contains all vehicles, as well as dealer names and partner numbers for the selected market. It may take up to 2 minutes to generate.",
		id: "dealerList.marketExport.intro",
	},
	language: {
		defaultMessage: "Language",
		id: "dealerList.marketExport.language",
	},
	lastMonth: {
		defaultMessage: "Last month",
		id: "dealerList.marketExport.timeFrame.lastMonth",
	},
	marketExport: {
		defaultMessage: "Export Vehicles",
		id: "dealerList.marketExport",
	},
	startDate: {
		defaultMessage: "Start date",
		id: "dealerList.marketExport.timeFrame.startDate",
	},
	startDateAfterEndDate: {
		defaultMessage: "The start date must not be after the end date.",
		id: "dealerList.marketExport.timeFrame.startDateAfterEndDate",
	},
	startDateHint: {
		defaultMessage: "You can select a start date from the past 12 months.",
		id: "dealerList.marketExport.timeFrame.startDateHint",
	},
	timeFrame: {
		defaultMessage: "Date range",
		id: "dealerList.marketExport.timeFrame.label",
	},
	timeFrameGreaterThan12Months: {
		defaultMessage: "The selected time frame is greater than 12 months.",
		id: "dealerList.marketExport.timeFrame.greaterThan12Months",
	},
	vehicleStatus: {
		defaultMessage: "Vehicle Status",
		id: "vehicleDetails.overview.summary.vehicleStatus", // shared
	},
})
